// extracted by mini-css-extract-plugin
export default {"settingsWrapper":"styles_settingsWrapper__T7jnU","breadcrumbWrapper":"styles_breadcrumbWrapper__8xomE"};